document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.manufacturer-toggle-wrap');
  if (!wrapper) return;

  const toggle = wrapper.querySelector('.manufacturer-toggle');
  if (!toggle) return;

  const links = toggle.querySelectorAll('a[data-key]');
  if (!links.length) return;

  const path = window.location.pathname.toLowerCase();
  const fullUrl = window.location.href.toLowerCase();

  // NEW: allow "no selection" pages
  // Put your Book Now product handle (or any unique slug) here
  const noDefaultOnPaths = [
    'https://proamgolfusa.com/products/book-now' // <-- change this to your Book Now product URL handle if different
  ];

  const isNoDefaultPage = noDefaultOnPaths.some(p => path === p || path.startsWith(p + '/'));

  let activeLink = null;

  // 1) Match by exact URL (strongest match)
  links.forEach((link) => {
    const href = (link.getAttribute('href') || '').toLowerCase();
    if (!href) return;

    const hrefBase = href.split('?')[0].split('#')[0].replace(/\/$/, '');
    const currentBase = fullUrl.split('?')[0].split('#')[0].replace(/\/$/, '');

    if (currentBase === hrefBase) activeLink = link;
  });

  // 2) Fallback: match by key in URL
  if (!activeLink) {
    links.forEach((link) => {
      const key = (link.getAttribute('data-key') || '').toLowerCase();
      if (!key) return;

      if (path.includes(key) || fullUrl.includes(key)) activeLink = link;
    });
  }

  // 3) IMPORTANT CHANGE:
  // If we didn't find a match:
  // - On Book Now page -> leave everything unselected
  // - On other pages -> (optional) you can still default to first link, but I'm leaving it OFF by default
  if (!activeLink && !isNoDefaultPage) {
    // If you still want a fallback on non-book-now pages, uncomment this:
    // activeLink = links[0];
  }

  // Apply classes + disable click for active only
  links.forEach((link) => {
    const isActive = activeLink && (link === activeLink);

    link.classList.toggle('active', isActive);

    if (isActive) {
      link.setAttribute('aria-current', 'page');
      link.setAttribute('tabindex', '-1');
      link.style.cursor = 'default';
      link.addEventListener('click', function (e) {
        e.preventDefault();
      });
    } else {
      link.removeAttribute('aria-current');
      link.removeAttribute('tabindex');
      link.style.cursor = '';
    }
  });

// Show Manufacturer: [Selected] or Manufacturer: Select one
const labelEl = wrapper.querySelector('.manufacturer-toggle-label');
if (labelEl) {
  const existing = wrapper.querySelector('.manufacturer-selected-name');
  if (existing) existing.remove();

  const selectedEl = document.createElement('span');
  selectedEl.className = 'manufacturer-selected-name';

  if (activeLink) {
    selectedEl.textContent = activeLink.textContent.trim();
    selectedEl.classList.remove('is-placeholder');
  } else {
    selectedEl.textContent = 'Select one';
    selectedEl.classList.add('is-placeholder');
  }

  labelEl.appendChild(selectedEl);
    }
  });
